import moment, { type MomentInstance } from '~~/utils/moment';
import camelCaseKeys from '~~/utils/camelCaseKeys';

export default class SubscriptionInvoice {
    attributes: Record<string, any>;

    constructor(attributes: Record<string, any>) {
        this.attributes = camelCaseKeys(attributes);
    }

    get id(): string {
        return this.attributes.id;
    }

    get date(): MomentInstance {
        return moment.unix(this.attributes.date);
    }

    get status(): string {
        return this.attributes.status;
    }

    // Chargebee sends due_date on payment_due/not_paid invoices; absent on older payloads.
    get dueDate(): MomentInstance | null {
        return this.attributes.dueDate ? moment.unix(this.attributes.dueDate) : null;
    }

    get total(): number {
        return this.attributes.total;
    }

    get totalPaid(): number {
        return this.attributes.amountPaid;
    }

    get totalDue(): number {
        return this.attributes.amountDue;
    }
}
